import Layout from './Layout'

export default Layout



// WEBPACK FOOTER //
// ./src/features/PublicOffer/components/Layout/index.js